<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { useMainStore } from '../stores/main-store'

const mainStore = useMainStore()

onMounted(() => {
  document.body.style.overflow = 'hidden'
})

onBeforeUnmount(() => {
  document.body.style.overflow = ''
})
</script>

<template>
  <div class="filter-popup">
    <button
      type="button"
      class="filter-popup__closer"
      @click="mainStore.filterPopup = false"
    >
      <i class="vn-icons-close"></i>
    </button>
    <div
      class="filter-popup__overlay"
      @click="mainStore.filterPopup = false"
    ></div>
    <div class="filter-popup__body">
      <div class="container"><slot></slot></div>
    </div>
  </div>
</template>

<style lang="scss">
@import '../scss/filter-popup';
</style>
